import { render, staticRenderFns } from "./Simple.vue?vue&type=template&id=35c505b0&"
import script from "./Simple.vue?vue&type=script&lang=js&"
export * from "./Simple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\bogo\\we-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35c505b0')) {
      api.createRecord('35c505b0', component.options)
    } else {
      api.reload('35c505b0', component.options)
    }
    module.hot.accept("./Simple.vue?vue&type=template&id=35c505b0&", function () {
      api.rerender('35c505b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Message/Detail/Simple.vue"
export default component.exports